/*
 * Purpose : Component to Add or Edit Brokers
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React,{useState} from "react";
import {  Col,  Row,  Button,  Form,  FormGroup,  Label,  Input,  CustomInput,  Alert} from "reactstrap";

import "./AddEditBrokers.css";
import Aux from "../../hoc/Auxilliary/Auxilliary";

const AddEditBrokers = (props) => {
    const [broker, setBroker] = useState(props.stateVals.broker);
    const [enableFlag, setEnableFlag] = useState(props.stateVals.enable==="Yes"?true:false)
    const [errors, setErrors] = useState({broker:"",validBroker:true})
    const [processing, setProcessing] = useState(false)
   
    // broker input text validator
    const brokerChangeHandler= (value) => {
        setBroker(value)        
        if(!value){
          setErrors({...errors, broker:'Broker is not valid!'})
        }
    }

    const submithandler =() => {
        if(!broker){
            setErrors({...errors, validBroker:false})
        }else{
            setErrors({...errors, validBroker:true})
            setProcessing(true)
            props.submithandler(props.stateVals.id,broker,enableFlag,props.stateVals.action)
        }
    }

    return (
    <Aux>
      <Form>
        <Alert color="danger" isOpen={!errors.validBroker}>Valid Broker is required.</Alert>
        <Row form>
          <Col md={12}>
            <FormGroup>
              <Label for="broker">Broker</Label>
              <Input
                type="text"
                name="broker"
                id="broker"
                placeholder=""
                value={broker}
                onChange={(e) => brokerChangeHandler(`${e.target.value}`)}
              />
            </FormGroup>
          </Col>
        </Row>
        {errors.broker.length > 0 && <span style={{ color:"#db2269", fontSize: "1em",  display: "relative" }} >{errors.broker}</span>}
        <Row>
          <FormGroup check>
            <div>
              <CustomInput
                type="checkbox"
                id="enableFlag"
                checked={enableFlag}
                onChange={(e) => setEnableFlag(!enableFlag)}
                label="Enable"
              />
            </div>
          </FormGroup>
        </Row>        
        <FormGroup style={{textAlign: "center", marginTop:"1rem"}}>
            <Row>
              <Col>
                <Button color="primary" className={"brokerFormBtn"} style={{backgroundColor:"#fb8734"}}
                        value="" 
                        onClick={()=>submithandler()}
                        disabled={processing}>
                        { processing && <span><i className="fa fa-spinner fa-spin"></i>  Processing... </span> }
                        { !processing && <span>Submit</span> }                                
                </Button>
              </Col>
              <Col>
                <Button color="secondary" className={"brokerFormBtn"} value="" onClick={props.closeHandler}>Close</Button>
              </Col>
            </Row>
        </FormGroup>
      </Form>
    </Aux>
  );
};
export default AddEditBrokers;